import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  cursor: pointer;
`;

export const StyledLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
`;
